import { BROADCAST_MUTE_AUDIO } from '../Types';
import { commonWebAnalytics } from '@studio/metrics/client/web/commonWebAnalytics';

function muteAudio(canUnmute = true, isRemoteToggle = false) {
  return async (dispatch, getState) => {
    const {
      meeting: { meetingSession }
    } = getState();

    const sliPayload = {
      microphoneState: 'OFF',
      isRemoteToggle
    };

    const audioVideo = meetingSession.audioVideo;

    // Only measure SLI when there's an actual state change
    const wasMuted = audioVideo.realtimeIsLocalAudioMuted();

    const unsubscribe = () => {
      audioVideo.realtimeUnsubscribeToMuteAndUnmuteLocalAudio(onMuteChange);
    };

    let settled = false;

    const onMuteChange = muted => {
      if (muted) {
        settled = true;
        commonWebAnalytics.endStudioMicrophoneToggled(sliPayload);
        unsubscribe();
      }
    };

    if (!wasMuted) {
      audioVideo.realtimeSubscribeToMuteAndUnmuteLocalAudio(onMuteChange);
      commonWebAnalytics.startStudioMicrophoneToggled(sliPayload);
    }

    try {
      audioVideo.realtimeSetCanUnmuteLocalAudio(canUnmute);
      audioVideo.realtimeMuteLocalAudio();

      // Deterministic fallback: if the callback didn't fire, end SLI based on confirmed state
      if (!wasMuted && !settled) {
        unsubscribe();
        const isMuted = audioVideo.realtimeIsLocalAudioMuted();
        commonWebAnalytics.endStudioMicrophoneToggled(
          isMuted
            ? sliPayload
            : { ...sliPayload, error: 'Mute state not confirmed by callback' }
        );
      }

      const action = {
        type: BROADCAST_MUTE_AUDIO,
        payload: audioVideo.realtimeIsLocalAudioMuted()
      };

      dispatch(action);
    } catch (error) {
      console.error('[muteAudio] Failed to mute microphone:', error);

      if (!wasMuted && !settled) {
        unsubscribe();
        commonWebAnalytics.endStudioMicrophoneToggled({
          ...sliPayload,
          error: error?.message
        });
      }

      throw error;
    }
  };
}

export default muteAudio;
